import { render, staticRenderFns } from "./AddSuperBom.vue?vue&type=template&id=b1e40b44"
import script from "./AddSuperBom.vue?vue&type=script&lang=js"
export * from "./AddSuperBom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports